export default __webpack_public_path__ + "static/media/laundry2-after-2048w.74a26085.png";